// Step 2
// Personal user Details

import React, { useState, useEffect, useRef } from 'react'
import InputFields from "../../common/input";

export default function PersonalDetailStep({languages, currentStep, taxNumberIN, locationData, inputPersonalEl, stepNo, inputFields, personalDetailsSubmit, inputChange, inputPhoneChange, onFieldBlur, emailChecking}) {

  if (currentStep !== stepNo) {
    return null
  } 

  return(
    <div className='flex justify-evenly align-center tablet:mt-5 tablet:mx-10'>
      <form id='personal-details' className='w-full tablet:px-10'>
      {/* Personal Details */}
      <InputFields 
        languages        = {languages}   
        inputFields      = {inputFields} 
        inputChange      = {inputChange}
        inputPhoneChange = {inputPhoneChange}
        onFieldBlur      = {onFieldBlur}
        inputEl          = {inputPersonalEl}
        locationData     = {locationData}
        taxNumberIN      = {taxNumberIN}
        emailChecking    = {emailChecking}
      />

      </form>
    </div>
  );
}